export const PIN_RESETTING_STEPS = {
  CONFIRMATION_CODE: 'confirmation-code',
  PIN: 'pin',
  CONFIRMATION_PIN: 'confirmation-pin'
} as const
